import { FileInput, FileX2, Plus } from "lucide-react";
import { Link } from "react-router-dom";

const AppHeader = ({ title, addAction, links, link, requestPath }) => {
  return (
    <div className="flex flex-col">
      <div className="rounded-md text-text-1 py-4 flex justify-between items-center text-center">
        <h2 className="header-text">{title}</h2>
        {requestPath && (
          <div className="flex gap-1.5 items-center justify-center">
            <button className="header-btn" onClick={(e) => {}}>
              <FileX2 size={20} />
            </button>
            <button className="header-btn" onClick={(e) => {}}>
              <FileInput size={20} />
            </button>
            {link ? (
              <Link className="header-btn" to={link}>
                <Plus size={20} />
              </Link>
            ) : (
              <button className="header-btn" onClick={() => addAction()}>
                <Plus size={20} />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AppHeader;
